<p-fileUpload
  #fileUpload
  name="myfile[]"
  [multiple]="multiple"
  [accept]="accept"
  maxFileSize="1073741824"
  styleClass="p-0"
  mode="advanced"
  [files]="files"
  [customUpload]="true"
  [disabled]="uploadProgress.length > 0"
  [auto]="true"
  (uploadHandler)="addFiles($event)"
  invalidFileTypeMessageDetail=""
  [invalidFileTypeMessageSummary]="'error.fileupload.wrong.filetype' | translate | prepareForPrimeNgTranslation">
  <ng-template pTemplate="content" let-files>
    <div
      class="rounded-border flex flex-col items-center justify-center border border-dashed border-gray-400 bg-gray-100 p-4">
      <i class="fa-regular fa-arrow-up-from-line text-surface-400 dark:text-surface-400 p-4 text-6xl"></i>
      <button
        pButton
        [disabled]="uploadProgress.length > 0"
        (click)="fileUpload.choose()"
        icon="fa-regular fa-folder-open"
        [label]="'fileupload.title' | translate"></button>
      <p class="mt-2 mb-0 text-gray-600">{{ 'fileupload.description' | translate }}</p>
    </div>
    <div
      class="flex flex-wrap gap-2 p-0"
      [ngClass]="{
        'pt-2': files.length
      }">
      <app-document
        *ngFor="let file of files; let i = index"
        [document]="file"
        [uploadProgress]="uploadProgress[i]?.progress"
        [uploadStatus]="uploadProgress[i]?.status"
        class="w-full"
        (removeDocument)="fileUpload.remove($event, i); removeFile(i)"
        (cancelUpload)="handleCancelUpload(uploadProgress, i)"></app-document>
    </div>
  </ng-template>
  <ng-template pTemplate="file"></ng-template>
  <ng-template pTemplate="empty"></ng-template>
  <ng-template pTemplate="header"></ng-template>
  <ng-template pTemplate="buttonbar"></ng-template>
</p-fileUpload>
